export default __webpack_public_path__ + "static/media/LEARN-HOVER-ANIM.19a3479a.gif";